import { render, staticRenderFns } from "./managedData.vue?vue&type=template&id=0c3c177a&"
import script from "./managedData.vue?vue&type=script&lang=js&"
export * from "./managedData.vue?vue&type=script&lang=js&"
import style0 from "./managedData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports